import { pickBy } from '@/utils'
import AttrHotSetting from './attr-hotsetting'

export default {
  name: 'imgHotzone',
  setting: [
    { label: '標題', key: 'title', component: 'input', value: '熱區圖' },
    { label: '副標題', key: 'subtitle', component: 'input', value: '圖上隨意畫塊塊' },
    { label: '元件間距', key: 'padded', component: 'switch', value: true },
    {
      label: '熱區設定',
      key: 'data',
      component: function (h, { key }) {
        return <AttrHotSetting v-model={this.value[key]} />
      },
      value: { imgUrl: '', data: [] }
    }
  ],
  transformIn: (v) => {
    const {
      name,
      base,
      config: { imgUrl },
      data
    } = v
    return {
      name,
      ...base,
      data: {
        imgUrl,
        data
      }
    }
  },
  transformOut: (v) => {
    return pickBy(v, {
      name: 'name',
      base: (v) => {
        return pickBy(v, {
          title: 'title',
          subtitle: 'subtitle',
          padded: 'padded'
        })
      },
      config: ({ data }) => {
        return pickBy(data, {
          imgUrl: 'imgUrl'
        })
      },
      data: 'data.data'
    })
  }
}
